import React from "react";
import { FILAS_QR_LOGIN, LADO_QR_LOGIN, URL_QR_LOGIN } from "./qrLogin";

// QR de la pantalla de inicio de sesión de la app (#1686, R32). Dibuja la matriz precalculada de
// `qrLogin.js` (la genera `scripts/generar-qr-login.js`): cuadrados con `var(--qr)` sobre `var(--qr-bg)`,
// sin librería en el bundle. Lleva SOLO la URL fija de login: nunca un token, correo ni id de la cuenta.
// `data-url` expone esa URL y `data-modulos` la matriz (LADO x LADO caracteres "0"/"1", fila por fila)
// para que el test R32 la compare contra `qrcode.create(url)`.
// Cubre R32 — .claude/specs/1686-checklist-uso-celular/

// Margen blanco alrededor, en módulos: la zona de silencio que exige el estándar del QR (4). Va dentro
// del SVG para que escanee igual aunque el contenedor cambie su padding.
const MARGEN = 4;

const MODULOS = FILAS_QR_LOGIN.join("");

export default function QrLogin({ size = 156, ...rest }) {
  const total = LADO_QR_LOGIN + MARGEN * 2;
  const cuadrados = [];
  FILAS_QR_LOGIN.forEach((fila, y) => {
    for (let x = 0; x < fila.length; x += 1) {
      if (fila[x] === "1") {
        cuadrados.push(
          <rect key={`${x}-${y}`} x={x + MARGEN} y={y + MARGEN} width={1} height={1} fill="var(--qr)" />
        );
      }
    }
  });
  return (
    <svg
      role="img"
      aria-label="Código QR para abrir SmartDx en el celular"
      data-testid="app-celular-qr"
      data-url={URL_QR_LOGIN}
      data-modulos={MODULOS}
      width={size}
      height={size}
      viewBox={`0 0 ${total} ${total}`}
      shapeRendering="crispEdges"
      style={{ display: "block" }}
      {...rest}
    >
      <rect width={total} height={total} fill="var(--qr-bg)" />
      {cuadrados}
    </svg>
  );
}
